<ng-template>
  <div (click)="onClick()" [class.no-padding]="!hasPadding" [class.filter]="isFilter" class="dropdown-content">
    <ng-content></ng-content>
  </div>
</ng-template>
